module.exports = __webpack_public_path__ + "img/0.a0049218.jpg";